// extracted by mini-css-extract-plugin
module.exports = {"storeContainer":"_store_storeContainer__Bx6Pp","storeHeader":"_store_storeHeader__h11XX","storeWrapper":"_store_storeWrapper__hmKgd","storeArtist":"_store_storeArtist__nSN2N"};